<template>
  <b-form-group
    :label="$t(label)"
    class="input-label"
    v-b-tooltip.hover.right
    :title="$t(tooltip)"
  >
    <b-input-group class="mb-3">
      <b-form-input
        v-model="dataInputText"
        v-mask="mascaraDataTela"
        :readonly="readonly"
        :placeholder="$t('system.date_format_placeholder')"
        :state="isValid"
        type="text"
      ></b-form-input>
      <b-input-group-append>
        <b-form-datepicker
          v-model="dataInterna"
          :min="minDate"
          :max="maxDate"
          button-only
          :labelHelp="$t('componente.labelHelp')"
          :labelPrevMonth="$t('componente.labelPrevMonth')"
          :labelPrevYear="$t('componente.labelPrevYear')"
          :labelNextMonth="$t('componente.labelNextMonth')"
          :labelNextYear="$t('componente.labelNextYear')"
          :labelCurrentMonth="$t('componente.labelCurrentMonth')"
          :labelNoDateSelected="$t('componente.labelNoDateSelected')"
          :locale="this.$i18n.locale"
        ></b-form-datepicker>
      </b-input-group-append>
    </b-input-group>
  </b-form-group>
</template>

<script>
import moment from "moment";

export default {
  props: {
    label: {
      type: String,
    },
    minDate: {
      type: String,
    },
    maxDate: {
      type: String,
    },
    tooltip: {
      type: String,
    },
    required: {
      type: Boolean,
      default: false,
    },
    formato: {
      type: String,
      default: "YYYY-MM-DD",
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    value: {},
  },

  created() {
    this.dataInterna = moment(this.value, this.formato).format(
      this.formatoDataInt
    );
  },

  data() {
    return {
      mascaraDataTela: "##/##/####", // Máscara para digito
      formatoDataTela: this.$t("system.date_format"), // Formato de data de acordo com o idioma (DD/MM/YYYY para pt MM/DD/YYYY para en)
      formatoDataInt: "YYYY-MM-DD", // Formato de data para operações internas do componente
      dataInterna: "Invalid date",
      dataInputText: "Invalid date",
    };
  },

  watch: {
    value(val) {
      this.dataInterna = moment(val, this.formato).format(this.formatoDataInt);
    },

    dataInterna(val) {
      if (val && val != "Invalid date") {
        this.$emit(
          "input",
          moment(val, this.formatoDataInt).format(this.formato)
        );
        this.dataInputText = moment(val, this.formatoDataInt).format(
          this.formatoDataTela
        );
      } else {
        this.dataInputText = null;
        this.$emit("input", null);
      }
    },

    dataInputText(val) {
      if (
        val &&
        val.length == 10 &&
        moment(val, this.formatoDataTela).isValid()
      ) {
        this.dataInterna = moment(val, this.formatoDataTela).format(
          this.formatoDataInt
        );
      } else {
        this.dataInterna = "Invalid date";
      }
    },
  },

  computed: {
    isValid() {
      let _isvalid = moment(this.dataInterna, this.formatoDataInt).isValid();
      if (this.required) {
        return (
          this.dataInterna !== "Invalid date" &&
          this.dataInterna.length == 10 &&
          _isvalid
        );
      } else return null;
    },
  },
};
</script>
